import { redirect } from 'react-router-dom';
import { getRequiredTests } from './api';
import { createAppStore } from '../store/index';
import { cartActions } from '../store/cart';
import { toast } from 'react-toastify';

export function getTokenDuration() {
  const storedExpirationDate = sessionStorage.getItem('expiration');
  const expirationDate = new Date(storedExpirationDate);
  const now = new Date();
  const duration = expirationDate.getTime() - now.getTime();
  return duration;
}

export function getAuthToken() {
  const token = sessionStorage.getItem('token');

  if (!token) {
    return null;
  }

  const tokenDuration = getTokenDuration();

  if (tokenDuration < 0) {
    return 'EXPIRED';
  }

  return token;
}

export function tokenLoader() {
  const token = getAuthToken();
  return token;
}

export function checkAuthLoader() {
  const token = getAuthToken();
	console.log(token);
  if (token === null || token === "EXPIRED") {
	console.log(token);
	sessionStorage.clear();
    return redirect('/Login');
  }
}

export async function addRequiredStateTest (dispatch) {
	const reqTests = await getRequiredTests();
	let testInfoRA = {};
	if(reqTests.includes("CANNOT ORDER")) {
		testInfoRA="CANNOT ORDER";
	}else{
		if (reqTests.length !== 0) {
			for (let i = 0; i < reqTests.length; i++) {
				const testInfoR = Object.assign({ required: 1 }, reqTests[i]);
				testInfoRA = Object.assign({ aaoeanswers: { "none": "none" } }, testInfoR);
				dispatch(cartActions.add(testInfoRA));
			}
		}
		toast('Added To Cart');
	}
	return testInfoRA;
}